import { type UseQueryResult, useQuery } from 'react-query';
import { CommissionService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetCommission = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  brokerId?: string
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const commissionOptions = useQuery(
    ['getBrokerOptions', brokerId],
    async () => {
      if (brokerId) {
        return await handleRequest(
          CommissionService.getApiAwardApiAppCommissionCommissionsByBrokerIdAnync(brokerId)
        );
      }
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      },
    }
  );

  return commissionOptions;
};

export default useGetCommission;
